const URL = 'https://portal.incash.africa:5657/v1/';

export const development = {
    api: {
        url: URL,
        // url: 'https://api.incash.africa/v1/',
    }
    
}


export const staging = {
    api: {
        url: URL,
    }
}